define('modules/lp_integration/views/main',['require','exports','module','base/view','common/models/appstate','../collections/variant_collection','../collections/form_fields','../models/integration_email','../models/integration_post','../models/integration_mdirector','../models/integration_emblue','../models/integration_correodirect','../models/integration_zapier','./email_popup','./mdirector_popup','./emblue_popup','./webservice_popup','./correodirect_popup','./zapier_popup','../../duplicate_control/collection','../../duplicate_control/model','lib/util','ldsh!../templates/main'],function (require, exports, module) {
  'use strict';
  var BaseView = require('base/view'),
    AppState = require('common/models/appstate'),
    VariantCollection = require('../collections/variant_collection'),
    FormFieldsCollection = require('../collections/form_fields'),
    EmailModel = require('../models/integration_email'),
    WebServiceModel = require('../models/integration_post'),
    MDirectorModel = require('../models/integration_mdirector'),
    EmBlueModel = require('../models/integration_emblue'),
    CorreoDirectModel = require('../models/integration_correodirect'),
    ZapierModel = require('../models/integration_zapier'),
    EmailModalView = require('./email_popup'),
    MDirectorModalView = require('./mdirector_popup'),
    EmBlueModalView = require('./emblue_popup'),
    WebServiceModalView = require('./webservice_popup'),
    CorreoDirectModalView = require('./correodirect_popup'),
    ZapierModalView = require('./zapier_popup'),
    DuplicateControlCollection = require('../../duplicate_control/collection'),
    DuplicateControlModel = require('../../duplicate_control/model'),
    util = require('lib/util');

  module.exports = BaseView.extend({
    template: require('ldsh!../templates/main'),
    events: {
      'click .js-email': 'showEmailPopUp',
      'click .js-email-active': 'toggleEmail',
      'click .js-mdirector': 'showMDirectorPopUp',
      'click .js-mdirector-active': 'toggleMDirector',
      'click .js-emblue': 'showEmBluePopUp',
      'click .js-emblue-active': 'toggleEmBlue',
      'click .js-post': 'showWebServicePopUp',
      'click .js-post-active': 'toggleWebService',
      'click .js-correodirect': 'showCorreoDirectPopUp',
      'click .js-correodirect-active': 'toggleCorreoDirect',
      'click .js-zapier': 'showZapierPopUp',
    },
    defaultFormFields: [
      'ip_address',
      'http_user_agent',
      'http_referer',
      'timestamp',
      'url',
      'confirmation_url',
      'variant_name',
      'variants_id',
      'visits_id',
      'pages_id',
    ],

    initialize: function (options) {
      this.variants = new VariantCollection([], { pageId: this.model.id });
      this.emailData = new EmailModel({ id: 'email' }, { pageId: this.model.id });
      this.mdirectorData = new MDirectorModel({ id: 'mdirector' }, { pageId: this.model.id });
      this.emBlueData = new EmBlueModel({ id: 'emblue' }, { pageId: this.model.id });
      this.duplicateControls = new DuplicateControlCollection();
      this.webserviceData = new WebServiceModel({ id: 'webservice' }, { pageId: this.model.id });
      this.correodirectData = new CorreoDirectModel(
        { id: 'correodirect' },
        { pageId: this.model.id }
      );
      this.zapierData = new ZapierModel({ id: 'zapier' }, { pageId: this.model.id });

      this.formFields = new FormFieldsCollection();

      this.listenTo(this.emailData, 'change:active', this._updateStatusButtons);
      this.listenTo(this.mdirectorData, 'change:active', this._updateStatusButtons);
      this.listenTo(this.emBlueData, 'change:active', this._updateStatusButtons);
      this.listenTo(this.webserviceData, 'change:active', this._updateStatusButtons);
      this.listenTo(this.correodirectData, 'change:active', this._updateStatusButtons);
      this.listenTo(this.variants, 'reset', this._parseFormFields);
      //load data
      this.variants.fetch({
        data: $.param({ active: true, step_stats: false }),
        reset: true,
        success: function () {
          AppState.toggleNavigation(true);
        },
      });
      this.emailData.fetch();
      this.mdirectorData.fetch();
      this.emBlueData.fetch();
      this.webserviceData.fetch();
      this.correodirectData.fetch();
      this.zapierData.fetch();
    },
    helpers: function () {
      return {
        isCorreoDirectActive: this._checkIfCorreoDirectIsAvailable(),
        hasMDirectorServiceEnabled: AppState.hasMDirectorServiceEnabled(),
      };
    },
    showEmailPopUp: function (e) {
      //display email modal
      var emailPopUp = new EmailModalView({
        model: this.emailData,
      });
    },
    showMDirectorPopUp: function (e) {
      var self = this,
        pageId = this.model.id,
        type = DuplicateControlModel.MDIRECTOR_TYPE;
      this.duplicateControls.fetchByPageIdAndType(pageId, type).done(function () {
        var duplicateControlModel =
          self.duplicateControls.first() || DuplicateControlModel.create(pageId, type);
        var mdirectorPopUp = new MDirectorModalView({
          model: self.mdirectorData,
          formFields: self.formFields,
          defaultFields: self.defaultFormFields,
          duplicateControlModel: duplicateControlModel,
        });
      });
    },
    showEmBluePopUp: function (e) {
      var self = this,
        pageId = this.model.id,
        type = DuplicateControlModel.EMBLUE_TYPE;
      this.duplicateControls.fetchByPageIdAndType(pageId, type).done(function () {
        var duplicateControlModel =
          self.duplicateControls.first() || DuplicateControlModel.create(pageId, type);
        var emBluePopUp = new EmBlueModalView({
          model: self.emBlueData,
          formFields: self.formFields,
          defaultFields: self.defaultFormFields,
          duplicateControlModel: duplicateControlModel,
        });
      });
    },
    showWebServicePopUp: function (e) {
      //display email modal
      var webservicePopUp = new WebServiceModalView({
        model: this.webserviceData,
        formFields: this.formFields,
        defaultFields: this.defaultFormFields,
      });
    },
    showCorreoDirectPopUp: function (e) {
      //display correo direct modal
      var correodirectPopUp = new CorreoDirectModalView({
        model: this.correodirectData,
        formFields: this.formFields,
        defaultFields: this.defaultFormFields,
        onSave: function (popUp) {
          popUp.model.save(null, {
            patch: true,
            success: _.bind(popUp.hide, popUp),
          });
        },
      });
    },
    showZapierPopUp: function (e) {
      //display zapier modal
      var zapierPopUp = new ZapierModalView({
        model: this.zapierData,
      });
    },
    toggleEmail: function (e) {
      var isActive = this.emailData.get('active');

      if (!isActive) {
        //trying to activate an invalid integration
        if (this.emailData.isValid()) {
          this.emailData.set('active', !isActive);
          this.emailData.save(null, { patch: true });
        } else {
          this.showEmailPopUp(e);
        }
      } else {
        this.emailData.set('active', !isActive);
        this.emailData.save(null, { patch: true });
      }
    },
    toggleMDirector: function (e) {
      this.mdirectorData.set('active', !this.mdirectorData.get('active'));
      this.mdirectorData.save(null, { patch: true });
    },
    toggleEmBlue: function (e) {
      var isActive = this.emBlueData.get('active');

      if (!isActive) {
        //trying to activate an invalid integration
        if (this.emBlueData.isValid()) {
          this.emBlueData.set('active', !isActive);
          this.emBlueData.save(null, { patch: true });
        } else {
          this.showEmBluePopUp(e);
        }
      } else {
        this.emBlueData.set('active', !isActive);
        this.emBlueData.save(null, { patch: true });
      }
    },
    toggleWebService: function (e) {
      var isActive = this.webserviceData.get('active');
      this.webserviceData.set('active', !isActive);
      if (this.webserviceData.isValid()) {
        this.webserviceData.save(null, { patch: true });
      } else {
        if (!isActive) {
          //trying to active invalid integration
          this.showWebServicePopUp(e);
        } else {
          //deactivate
          this.webserviceData.set('active', false);
          this.webserviceData.save(null, { patch: true });
        }
      }
    },
    toggleCorreoDirect: function (e) {
      var isActive = this.correodirectData.get('active');
      this.correodirectData.set('active', !isActive);
      if (this.correodirectData.isValid()) {
        this.correodirectData.save(null, { patch: true });
      } else {
        if (!isActive) {
          //trying to active invalid integration
          this.showCorreoDirectPopUp(e);
        } else {
          //deactivate
          this.correodirectData.set('active', false);
          this.correodirectData.save(null, { patch: true });
        }
      }
    },

    onRender: function () {
      this._updateStatusButtons();
      this.$el.i18n();
    },

    _checkIfCorreoDirectIsAvailable: function () {
      return !util.isAnyVariantAMP(this.variants) && AppState.isCorreoDirectAvailable();
    },

    _parseFormFields: function (variants) {
      variants.reduce(this._extractFormFieldsFromVariant, this.formFields, this);
    },

    _extractFormFieldsFromVariant: function (formFields, variant) {
      if (variant.get('active')) {
        variant.content.reduce(this._extractFormFieldsFromStep, formFields, this);
      }
      return formFields;
    },

    _extractFormFieldsFromStep: function (formFields, step) {
      var num = step.get('step'),
        stepForm = step.hasElement('element:form'),
        stepFields = formFields.getFieldsForStep(num);
      if (stepForm) {
        _.each(
          stepForm.toJSON().fields,
          function (field) {
            // backwards compatibility
            var nameAttr = field.nameAttr || field.labelText;
            if (field.name != 'custom:fblogin' && !_.contains(stepFields, nameAttr)) {
              stepFields.push(nameAttr);
            }
          },
          this
        );
        formFields.setFieldsForStep(num, stepFields);
      }
      return formFields;
    },

    _updateStatusButtons: function () {
      var integrations = [
          this.emailData,
          this.mdirectorData,
          this.emBlueData,
          this.webserviceData,
          this.correodirectData,
          this.zapierData,
        ],
        selectors = ['email', 'mdirector', 'emblue', 'post', 'correodirect', 'zapier'];
      _.each(
        integrations,
        function (model, index) {
          var name = selectors[index],
            isActive = model.get('active');

          this.$('.js-' + name)
            .toggleClass('ed-btn-danger', !isActive)
            .toggleClass('ed-btn-success', isActive);
          this.$('.js-' + name + '-active')
            .toggleClass('ed-btn-danger', !isActive)
            .toggleClass('ed-btn-success', isActive);
          this.$('.js-' + name + '-active i')
            .toggleClass('ri-close-circle-line', !isActive)
            .toggleClass('ed-icon-ok', isActive);
        },
        this
      );
    },
  });
});

